export const siteLink = "https://galaktikame.ru"
export const siteLinkSlash = "https://galaktikame.ru/"

export const prevSiteLink = "https://galaktika.me"
export const prevSiteLinkSlash = "https://galaktika.me/"

export const replacedLink = link => link.replace(siteLink, "").replace(prevSiteLink, "")


export const STORE_NAME = 'Галактика'